import {createEventBus} from '@malt/vue-event-bus/create-event-bus';
import type {EditionOpenedEntryPoint, RecommendationRequestStartedEntryPoint} from '~/config/TrackingEvents';

// TODO: The return type of events should be void, instead of undefined.
// TODO: Use enum for better typing
export type EditModeEvents = {
    'about:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'about:updated': undefined;
    'admin-panel:close': undefined;
    'admin-panel:open': undefined;
    'appraisals:updated': undefined;
    'breadcrumb:edit-mode': undefined;
    'breadcrumb:updated': undefined;
    'categories:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'categories:updated': undefined;
    'certifications:edit-mode': {certificationId: number | undefined; entryPoint: EditionOpenedEntryPoint};
    'certifications:updated': undefined;
    'description:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'description:updated': undefined;
    'dev-tools:edit-mode': undefined;
    'educations:add-mode': {entryPoint: EditionOpenedEntryPoint};
    'educations:edit-mode': {educationId: number; entryPoint: EditionOpenedEntryPoint};
    'educations:deleted': void;
    'educations:updated': undefined;
    'experiences:cancel': undefined;
    'experiences:resume-import-mode': {entryPoint: EditionOpenedEntryPoint};
    'experiences:cancel-import-hotjar-survey': undefined;
    'experiences:selection-mode': {entryPoint?: EditionOpenedEntryPoint} | undefined;
    'experiences:updated': undefined;
    'expertises-skills-strategy:updated': void;
    'expertises-skills:edit-mode': undefined;
    'expertises-skills:rate-mode': undefined;
    'expertises-skills:updated': void;
    'headline:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'header:edit-mode': {entryPoint: EditionOpenedEntryPoint; scrollToElement?: string};
    'header:updated': undefined;
    'industry-expertise:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'industry-expertise:updated': undefined;
    'languages:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'location-preferences:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'photo:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'photo:updated': undefined;
    'price:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'profile:updated': undefined;
    'recommendations:edit-mode': {entryPoint: RecommendationRequestStartedEntryPoint};
    'recommendations:updated': undefined;
    'reputation:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'reputation:updated': undefined;
    'resume-import:updated': undefined;
    'skill-set:edit-mode': {entryPoint: EditionOpenedEntryPoint};
    'skill-set:updated': void;
    'social-share-seo:edit-mode': undefined;
    'social-share-seo:updated': undefined;
    'task-list:completed': undefined;
};

type ExternalUserActionEvents = {
    'external-action:recommendations:add': void | {experienceId: string};
    'external-action:recommendations:added': undefined;
    'external-action:recommendations:ready': void;
    'onboarding:closed': undefined;
    'shortlist:display-choice': undefined;
    'translation:request': undefined;
    'translation:restore': undefined;
    'wishlist:add-mode': undefined;
    'wishlist:added': undefined;
    'wishlist:edit-mode': undefined;
};

type MainComponentEvents = {
    'main:recommendations:ready': void;
    'main:recommendations:scroll-to': void;
};

type VettingEvents = {
    'verticalAcceptToRegular:open': any;
    'verticalRefuseSilentlyToStrategy:open': any;
    'verticalRefuseToStrategy:open': any;
    'verticalSuggestToStrategy:open': string[];
};

type SimilarProfileNavigationEvents = {
    'similarProfiles:previous': void;
    'similarProfiles:next': void;
};

export type Events = EditModeEvents & ExternalUserActionEvents & MainComponentEvents & VettingEvents & SimilarProfileNavigationEvents;

export const eventBus = createEventBus<Events>();
